import { dew as _encodeDeployDataDew } from "../../utils/abi/encodeDeployData.js";
import { dew as _sendTransactionDew } from "./sendTransaction.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.deployContract = void 0;
  const encodeDeployData_js_1 = _encodeDeployDataDew();
  const sendTransaction_js_1 = _sendTransactionDew();
  function deployContract(walletClient, {
    abi,
    args,
    bytecode,
    ...request
  }) {
    const calldata = (0, encodeDeployData_js_1.encodeDeployData)({
      abi,
      args,
      bytecode
    });
    return (0, sendTransaction_js_1.sendTransaction)(walletClient, {
      ...request,
      data: calldata
    });
  }
  exports.deployContract = deployContract;
  //# sourceMappingURL=deployContract.js.map
  return exports;
}